import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';

import { ProductDetailFormValues, productDetailSchema } from '../model/schema';

export const useProductDetailForm = (
  defaultValues?: Partial<ProductDetailFormValues>
) => {
  return useForm<ProductDetailFormValues>({
    resolver: zodResolver(productDetailSchema),
    defaultValues: {
      name: '',
      ...defaultValues
    }
  });
};
